import { senderRoutes } from '@/lib/sender-routes';
import SenderAuthJobsPage from '@/pages/sender/auth-jobs';
import SenderConsolePage from '@/pages/sender/eva/spammer-console-placeholder';
import SenderStatsPage from '@/pages/sender/eva/stats';
import SenderLaunchPage from '@/pages/sender/launch';
import SenderMorePage from '@/pages/sender/more';
import SenderNowPage from '@/pages/sender/now';
import SenderRunDetailPage from '@/pages/sender/run-detail';
import SenderScenarioEditorPage from '@/pages/sender/scenario-editor';
import SenderScenariosPage from '@/pages/sender/scenarios';
import SenderSendPage from '@/pages/sender/send';
import SenderSessionsPage from '@/pages/sender/sessions';
import SenderSettingsPage from '@/pages/sender/settings';
import { Navigate, type RouteObject } from 'react-router';

/** Shared tails for `/sender-app` and panel `/sender`. */
export const senderChildRoutes: RouteObject[] = [
	{ index: true, Component: SenderNowPage },
	{ path: 'send', Component: SenderSendPage },
	{ path: 'send/one', Component: SenderLaunchPage },
	{ path: 'accounts', Component: SenderSessionsPage },
	{ path: 'runs', element: <Navigate to={senderRoutes.hub} replace /> },
	{ path: 'runs/:id', Component: SenderRunDetailPage },
	{ path: 'console', Component: SenderConsolePage },
	{ path: 'more', Component: SenderMorePage },
	{ path: 'scenarios', Component: SenderScenariosPage },
	{ path: 'scenarios/new', Component: SenderScenarioEditorPage },
	{ path: 'scenarios/:id', Component: SenderScenarioEditorPage },
	{ path: 'stats', Component: SenderStatsPage },
	{ path: 'settings', Component: SenderSettingsPage },
	{ path: 'auth-jobs', Component: SenderAuthJobsPage },
	{ path: 'auth-jobs/:id', Component: SenderAuthJobsPage },
	{ path: 'overview', element: <Navigate to={senderRoutes.hub} replace /> },
	{ path: 'spammer/settings', element: <Navigate to={senderRoutes.scenarios} replace /> },
	{ path: 'spammer/console', element: <Navigate to={senderRoutes.console} replace /> },
	{ path: 'spammer', element: <Navigate to={senderRoutes.send} replace /> },
	{ path: 'sessions', element: <Navigate to={senderRoutes.accounts} replace /> },
	{ path: 'launch', element: <Navigate to={senderRoutes.sendOne} replace /> },
	{ path: 'domains', element: <Navigate to={senderRoutes.hub} replace /> },
	{ path: 'domains/landing/:id', element: <Navigate to={senderRoutes.hub} replace /> },
	{ path: 'domains/apk/:id', element: <Navigate to={senderRoutes.hub} replace /> },
	{ path: 'templates', element: <Navigate to={senderRoutes.hub} replace /> },
	{ path: 'templates/new', element: <Navigate to={senderRoutes.hub} replace /> },
];
